import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useBlockSpaceDialogFormValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  const schema = z
    .object({
      type: z.union([z.literal('permanent'), z.literal('specificDateAndTime')]),
      from: z.date().nullable(),
      to: z.date().nullable(),
    })
    .refine(
      data => {
        if (data.type === 'permanent') {
          return true;
        }

        return data.from;
      },
      {
        message: t('validation:required'),
        path: ['from'],
      },
    )
    .refine(
      data => {
        if (data.type === 'permanent') {
          return true;
        }

        return data.to;
      },
      {
        message: t('validation:required'),
        path: ['to'],
      },
    )
    .refine(
      data => {
        if (data.type === 'specificDateAndTime') {
          return data.from && data.to && data.from < data.to;
        }

        return true;
      },
      {
        message: t('validation:endDateMustBeGreater'),
        path: ['to'],
      },
    );

  return schema;
};
